var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V17C21 17.5523 20.5523 18 20 18H4C3.44772 18 3 17.5523 3 17V6ZM12.319 7.21797C12.197 6.92734 11.803 6.92733 11.681 7.21797L10.7932 9.33166C10.7426 9.45208 10.634 9.53467 10.5089 9.54782L8.31415 9.77847C8.01236 9.81019 7.89063 10.2023 8.11697 10.4137L9.76308 11.9507C9.85686 12.0382 9.89835 12.1719 9.87165 12.3004L9.40299 14.5567C9.33854 14.8669 9.65723 15.1093 9.91919 14.9492L11.8243 13.7855C11.8786 13.7523 11.9393 13.7357 12 13.7357C12.0607 13.7357 12.1214 13.7523 12.1757 13.7855L14.0808 14.9492C14.3428 15.1093 14.6615 14.8669 14.597 14.5567L14.1284 12.3004C14.1017 12.1719 14.1431 12.0382 14.2369 11.9507L15.883 10.4137C16.1094 10.2023 15.9876 9.81019 15.6859 9.77847L13.4911 9.54782C13.366 9.53467 13.2574 9.45209 13.2068 9.33167L12.319 7.21797Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 20C1.25 19.5858 1.58579 19.25 2 19.25H22C22.4142 19.25 22.75 19.5858 22.75 20C22.75 20.4142 22.4142 20.75 22 20.75H2C1.58579 20.75 1.25 20.4142 1.25 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStar1);
export default __webpack_public_path__ + "static/media/laptop-star-1.b633ed5ab854a55c79f37b9139998fcd.svg";
export { ForwardRef as ReactComponent };